var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveJobIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_5264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9688 1.08203C21.7563 1.08203 23.2188 2.54453 23.2188 4.33203V24.9695C23.2188 25.6195 22.7313 26.107 22.0813 26.107C21.8375 26.107 21.675 26.0258 21.4312 25.9445L13.6313 20.7445C13.55 20.6633 13.3875 20.6633 13.3063 20.7445L5.50625 25.9445C5.01875 26.2695 4.2875 26.1883 3.9625 25.6195C3.8 25.3758 3.71875 25.2133 3.71875 24.9695V4.33203C3.71875 2.54453 5.18125 1.08203 6.96875 1.08203H19.9688ZM19.9688 2.70703H6.96875C6.075 2.70703 5.425 3.35703 5.34375 4.25078V4.33203V24.0758L12.4125 19.3633C13.0625 18.957 13.7938 18.957 14.4438 19.282L14.6062 19.3633L21.675 24.0758V4.33203C21.675 3.43828 21.025 2.78828 20.1313 2.70703H19.9688Z",
    fill: "#C1D0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_5264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.46875 0.59375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveJobIcon);
export default __webpack_public_path__ + "static/media/save_job_icon.61bf10f4f8d9dc45ca60594dc2a62881.svg";
export { ForwardRef as ReactComponent };